﻿window.cRgpd = function (option) {
    var Me = this

    this.mGetNomSociete = function () {
        if (!option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite").length == 0) {
            var dataSociete = option.bddCtrl.mGetArray("societe")[0]
            if (dataSociete) {
                option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", dataSociete.nom)
            }
        }
        return option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite")
    }

    this.mGetAdresseEmailRgpd = function () {
        if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
            option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite", option.bddCtrl.utiCourant.adresse_email)
        }
        return option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite")
    }

    this.mShowPopupSaisieSociete = function (funcOk) {
        mConfirmPopup(function (contentElement) {
            $("<div/>").appendTo(contentElement).dxTextBox({
                labelMode: "Floating",
                label: "Nom de votre société",
                value: Me.mGetNomSociete(),
                onValueChanged: function (e) {
                    //if (e.value == null || e.value.length == 0) {
                    //    mNotify("Vous devez saisir un nom pour votre société.", "warning", 6000)
                    //}
                    option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", e.value)
                }
            })
        }, function () {
            if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
                mNotify("Vous devez saisir un nom pour votre société.", "warning", 6000)
                return false
            }
            funcOk()
            return true
        }, "Valider", function () {
        }, "Annuler", null, true, "Société qui envoi le mail")
    }

    this.mShowPopupSaisieSocieteEmailRgpdSociete = function (funcOk) {
        mConfirmPopup(function (contentElement) {
            var dxConf = $("<div/>").appendTo(contentElement).dxTextBox({
                labelMode: "Floating",
                label: "Libellé du lien pour votre politique de confidentialité",
                value: option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite"),
                onValueChanged: function (e) {
                    if (e.value == null || e.value.length == 0) {
                        e.component.option("value", "Politique de confidentialité")
                    } else {
                        option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite", e.value)
                    }
                }
            })
            $("<div/>").appendTo(contentElement).dxTextBox({
                labelMode: "Floating",
                label: "Nom de votre société",
                value: Me.mGetNomSociete(),
                onValueChanged: function (e) {
                    //if (e.value == null || e.value.length == 0) {
                    //    mNotify("Vous devez saisir un nom pour votre société.", "warning", 6000)
                    //}
                    option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", e.value)
                }
            })
            $("<div/>").appendTo(contentElement).dxCtrlTextEmail({
                labelMode: "Floating",
                label: "Adresse email du responsable de la RGPD",
                value: Me.mGetAdresseEmailRgpd(),
                onValueChanged: function (e) {
                    if (!dxAdrEmail.hasErreur) {
                        option.bddCtrl.paraAppli.mGetPara("nom_societe_politique_confidentialite", e.value)
                    }

                }
            })
        }, function () {
            if (!option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_politique_confidentialite").length == 0) {
                mNotify("Vous devez saisir un libellé du lien sur la politique de confidentialité.", "warning", 6000)
                return false
            }
            if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
                mNotify("Vous devez saisir un nom pour votre société.", "warning", 6000)
                return false
            }
            if (!option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite") || option.bddCtrl.paraAppli.mGetPara("adresse_email_politique_confidentialite").length == 0) {
                mNotify("Vous devez saisir une adresse email pour le responsable RGPD.", "warning", 6000)
                return false
            }
            funcOk()
            return true
        }, "Valider", function () {
        }, "Annuler", null, true, "Information pour votre politique de confidentialité")
    }

    this.mShowPolitiqueConfidentialite = function (nomSociete, emailRgpd, showClose = false) {
        var duree = option.bddCtrl.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees")
        var politiqueConfidentialite = $(`
            <div class="politique-confidentialite">
              <h4 style='text-align:center;margin-top:0;'>Politique de confidentialité</h4>

              <h5>Qui sommes-nous ?</h5>
              <p><b>${nomSociete}</b>, est responsable du traitement de vos données personnelles.<br>
              Contact : <a href="mailto:${emailRgpd}">${emailRgpd}</a>.</p>

              <h5>Quelles données traitons-nous ?</h5>
              <p>Nom, prénom, fonction, entreprise, adresse email, numéros de téléphone, ainsi que les données liées à nos échanges (emails envoyés, ouvertures, clics, notes de suivi).</p>

              <h5>D’où viennent vos données ?</h5>
              <p>Elles nous ont été transmises par vous-même, ou ont été obtenues à partir de sources publiques professionnelles (site internet de votre entreprise, annuaires professionnels). Vous pouvez nous demander la source précise à tout moment.</p>

              <h5>Pourquoi les utilisons-nous ?</h5>
              <ul>
                <li>Gérer notre relation commerciale avec nos clients (base légale : exécution du contrat).</li>
                <li>Vous adresser des informations et offres en lien avec votre activité professionnelle (base légale : notre intérêt légitime) ou, si vous êtes un particulier, avec votre consentement.</li>
              </ul>

              <h5>Qui y a accès ?</h5>
              <p>Uniquement nos équipes habilitées et nos prestataires techniques (hébergement, outil d’envoi d’emails), qui agissent sur nos instructions. Vos données ne sont ni vendues ni louées. Elles sont hébergées dans l’Union européenne.</p>

              <h5>Combien de temps les conservons-nous ?</h5>
              <ul>
                <li>Prospects : <b>${duree}</b> ans à compter de notre dernier échange à votre initiative.</li>
                <li>Clients : pendant la relation commerciale, puis 3 ans.</li>
                <li>Factures : 10 ans (obligation légale).</li>
              </ul>

              <h5>Suivi des emails</h5>
              <p>Nos emails peuvent contenir un pixel permettant de savoir s’ils ont été ouverts. Vous pouvez le désactiver via le lien présent dans chaque email.</p>

              <h5>Vos droits</h5>
              <p>Vous pouvez à tout moment accéder à vos données, les rectifier, les faire effacer, vous opposer à leur utilisation ou demander une limitation du traitement. Vous pouvez vous désinscrire de nos emails via le lien présent dans chaque message.</p>
              <p>Pour exercer vos droits : <a href="mailto:${emailRgpd}">${emailRgpd}</a>. Nous répondons dans un délai d’un mois.</p>
              <p>Vous pouvez également introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener">www.cnil.fr</a>.</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
            `);

        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            showMaximize: false,
            showClose: showClose,
            height: "100%",
            width: "100%",
            hideOnOutsideClick: false,
            shading: true,
            showTitle: true,
            //showCloseButton: false,
            contentTemplate: function (contentElement) {
                contentElement.css("text-align", "center")
                var dxScroll = $("<div style='width:100%;max-width:600px;display:inline-block;'/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                dxScroll.content().css("text-align", "left")
                dxScroll.content().html(politiqueConfidentialite)
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.hasLienDesinscription = function () {
        return $(option.html).find(".RGPDpopsoftADesinscription").length > 0 || $(option.html).find(".ADesinscription").length > 0
        // option.html.contains('class="ADesinscription"')
    }
    this.hasLienPixelTracking = function () {
        return $(option.html).find(".RGPDApopsoftDesactivepixeltracking").length > 0
    }
    this.hasChampNomSociete = function () {
        return $(option.html).find(".RGPDpopsoftAnomsociete").length > 0
    }
    this.hasLienPolitiqueConf = function () {
        return $(option.html).find(".RGPDpopsoftAPolitiqueconfidentialite").length > 0
    }
    this.hasChampSourceEmail = function () {
        return $(option.html).find(".RGPDpopsoftAsourceemail").length > 0
    }

    this.isOkLienDesinscription = function () {
        return option.data.rgpd_is_email_commercial == "0" || this.hasLienDesinscription() || option.data.rgpd_gere_lien_desinscription == "1"
    }
    this.isOkLienPixelTracking = function () {
        return option.data.rgpd_is_email_commercial == "0" || this.hasLienPixelTracking() || option.data.rgpd_gere_lien_pixel_suivi == "1"
    }
    this.isOkChampNomSociete = function () {
        return option.data.rgpd_is_email_commercial == "0" || this.hasChampNomSociete() || option.data.rgpd_gere_champ_societe == "1"
    }
    this.isOkLienPolitiqueConf = function () {
        return option.data.rgpd_is_email_commercial == "0" || this.hasLienPolitiqueConf() || option.data.rgpd_gere_lien_politique_conf == "1"
    }
    this.isOkChampSourceEmail = function () {
        return option.data.rgpd_is_email_commercial == "0" || this.hasChampSourceEmail() || option.data.rgpd_gere_champ_source_email == "1"
    }

    this.isOkRgpd = function () {
        return this.isOkLienDesinscription() && this.isOkLienPixelTracking() && this.isOkChampNomSociete() && this.isOkLienPolitiqueConf() && this.isOkChampSourceEmail()
    }

}